import React from 'react';
import { LineChart, TrendingDown, TrendingUp } from 'lucide-react';

function TrendChip({ delta, polarity, unit }) {
  if (delta == null) return null;
  const improved =
    polarity === 'lower_is_better' ? delta < 0 : polarity === 'higher_is_better' ? delta > 0 : delta > 0;
  const Icon = improved ? TrendingUp : TrendingDown;
  const color = improved ? 'text-emerald-600' : 'text-red-600';
  const suffix = unit === 'percent' ? '%' : unit === 'days' ? 'd' : '';
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium ${color}`}>
      <Icon className="w-3.5 h-3.5" />
      {delta > 0 ? '+' : ''}
      {delta}
      {suffix} vs prior
    </span>
  );
}

export default function OperationalHighlightRow({ tiles = [] }) {
  if (!tiles.length) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <LineChart className="w-6 h-6 text-blue-600" />
            <h2 className="text-2xl font-bold text-gray-900">Practice analytics highlights</h2>
          </div>
          <span className="text-sm text-gray-500">Custom metrics from feeds or manual entry</span>
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {tiles.map((tile) => (
          <div
            key={tile.id}
            className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow border-l-4 border-l-indigo-500"
          >
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-medium text-gray-600">{tile.label}</h3>
              <span className="text-[10px] uppercase tracking-wider text-indigo-700 bg-indigo-100 px-1.5 py-0.5 rounded shrink-0">
                Custom
              </span>
            </div>
            <p className="text-3xl font-bold text-gray-900">{tile.displayValue}</p>
            <div className="mt-2">
              <TrendChip delta={tile.delta} polarity={tile.polarity} unit={tile.unit} />
            </div>
            {tile.sourceLabel && (
              <p className="text-xs text-gray-500 mt-2 truncate" title={tile.sourceLabel}>
                Source: {tile.sourceLabel}
              </p>
            )}
            {tile.sparkline?.length > 0 && (
              <div className="flex items-end gap-0.5 h-6 mt-3">
                {tile.sparkline.map((v, i) => (
                  <div
                    key={i}
                    className="flex-1 bg-indigo-400/70 rounded-sm"
                    style={{ height: `${Math.max(20, Math.min(100, v))}%` }}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}
